// Conexões do cliente selecionado (#355). A conexão (login Google/Meta) é da organização; o backend
// diz, em `client_accounts` ({client_id: contas}), a quais clientes ela serve. Helpers puros.

const accountsOf = (conn, clientId) => Number(conn?.client_accounts?.[clientId] || 0)

// Sem cliente selecionado (visão agregada) mostra todas; com cliente, só as que têm contas dele.
export function visibleConnections(conns, clientId) {
  const list = conns || []
  return clientId ? list.filter((c) => accountsOf(c, clientId) > 0) : list
}

// Conexão autorizada que não serve a nenhum cliente (o picker de contas foi abandonado).
export function isUnlinked(conn) {
  return Object.values(conn?.client_accounts || {}).every((n) => !Number(n))
}

// "2 contas neste cliente" (ou "1 agenda") para o card, só quando há cliente selecionado.
export function clientHint(conn, clientId, noun = 'conta') {
  if (!clientId) return ''
  const n = accountsOf(conn, clientId)
  if (!n) return ''
  const label = noun === 'agenda' ? (n === 1 ? 'agenda' : 'agendas') : (n === 1 ? 'conta' : 'contas')
  return `${n} ${label} neste cliente`
}

// Aviso antes de desconectar: quais clientes e quantas contas deixam de sincronizar. '' se não há nenhum.
export function disconnectImpact(conn, clients) {
  const byId = new Map((clients || []).map((c) => [c.id, c.name]))
  const lines = Object.entries(conn?.client_accounts || {})
    .filter(([, n]) => Number(n) > 0)
    .map(([id, n]) => `• ${byId.get(id) || 'Cliente removido'}: ${n} ${Number(n) === 1 ? 'conta' : 'contas'}`)
  return lines.length ? `Esta conexão atende:\n${lines.join('\n')}\nElas deixam de sincronizar.` : ''
}
